import Account from 'lib/auth/Account';
import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myReduxProxy } from 'v5/api/_common/reduxProxy.connected';
import { myIntegrationApi } from '../../../api/integration/integration.api.connected';
import { createIntegrationService } from './IntegrationService.impl';

export const myIntegrationService = createIntegrationService({
  api: myIntegrationApi,
  queryClient,
  reduxProxy: myReduxProxy,
  resolveOrganizationId: () => Account.resolveFirstWorkspace()?.db_schema
});
